export class StateActions {
  static PROMOTE = "@STATE_PROMOTE";
  static DEMOTE = "@STATE_DEMOTE";
}